import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

export const joinRoom = (roomName: string, isPublic?: boolean) => {
  const socket = getOrCreateSocket();
  socket.emit("join", roomName, isPublic);
  store.setCurrentRoom(roomName);
};
